import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { PageHeader, Card, Button, Input, Select, Field, Stat, Textarea } from "@/components/UI";
import PriceUpdateModal from "@/components/PriceUpdateModal";
import { Plus, PencilSimple, Trash, Pill, ChartLine, Package as PackageIcon, ListChecks, Warning, Drop, TrendUp, CurrencyCircleDollar, ShoppingCart, Archive, ArrowCounterClockwise, UploadSimple, X, ArrowRight } from "@phosphor-icons/react";
import { toast } from "sonner";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer } from "recharts";
import { USAGE_UNITS, CATEGORIES, EMPTY, DOSE_UNITS_FOR, expiryBadge, EMPTY_BULL, EMPTY_PROTOCOL, muid } from "./constants";

export function MedStats() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/medicine-usage/stats").then(r => setS(r.data)).catch(() => {}); }, []);
  if (!s) return <div className="text-[#8a938c]">Yükleniyor...</div>;

  const Block = ({ title, data, testId }) => (
    <section data-testid={testId} className="space-y-4">
      <h3 className="heading text-2xl">{title}</h3>
      <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
        <Stat label="Toplam Kullanım Maliyeti" value={data.total_cost.toLocaleString("tr-TR")} unit="₺" tone="warn" />
        <Stat label="Kayıt Sayısı" value={data.total_records} unit="adet" />
        <Stat label="Farklı İlaç" value={data.top_medicines.length} unit="çeşit" />
      </div>
      <div className="grid lg:grid-cols-2 gap-4">
        <Card>
          <div className="text-xs uppercase tracking-widest text-[#6b746c] mb-2">En Çok Kullanılan (Maliyete göre)</div>
          <div style={{ height: 220 }}>
            <ResponsiveContainer>
              <BarChart data={data.top_medicines.slice(0, 6)} layout="vertical">
                <XAxis type="number" tick={{ fontSize: 10, fill: "#8a938c" }} />
                <YAxis type="category" dataKey="name" tick={{ fontSize: 11, fill: "#5e675e" }} width={90} />
                <Tooltip contentStyle={{ borderRadius: 6, border: "1px solid #E5E2DC" }} />
                <Bar dataKey="cost" fill="#C45B45" radius={[0, 4, 4, 0]} />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </Card>
        <Card className="!p-0 overflow-hidden">
          <table className="data-table">
            <thead><tr><th>İlaç</th><th className="text-right">Miktar</th><th className="text-right">Maliyet</th><th className="text-right">Kullanım</th></tr></thead>
            <tbody>
              {data.top_medicines.map((m, i) => (
                <tr key={m.name}>
                  <td className="font-semibold"><span className="text-xs text-[#8a938c] mr-2">#{i+1}</span>{m.name}</td>
                  <td className="text-right tabnum">{m.amount} {m.unit}</td>
                  <td className="text-right tabnum font-semibold text-[#C45B45]">{m.cost.toLocaleString("tr-TR")} ₺</td>
                  <td className="text-right tabnum">{m.count}x</td>
                </tr>
              ))}
              {!data.top_medicines.length && <tr><td colSpan={4} className="text-center py-6 text-[#8a938c]">Kullanım kaydı yok.</td></tr>}
            </tbody>
          </table>
        </Card>
      </div>
    </section>
  );

  return (
    <div className="space-y-10">
      <Block title="Haftalık (Son 7 Gün)" data={s.weekly} testId="weekly-usage-stats" />
      <div className="h-px bg-[#E5E2DC]" />
      <Block title="Aylık (Son 30 Gün)" data={s.monthly} testId="monthly-usage-stats" />
      <div className="h-px bg-[#E5E2DC]" />
      <Block title="Yıllık (Son 365 Gün)" data={s.yearly} testId="yearly-usage-stats" />
    </div>
  );
}

// ---------------- MEDICINE COUNTS (Aylık Sayım) ----------------
